import React from 'react';
import '../styles/ARVEstimateDescription.css';
import { formatterLong } from '../styles/GlobalStyles';

function ARVEstimateHeading(props) {
    const arvEstimate = props.arvEstimate;
    const arvRange = props.arvRange;

    const values = [
        {
            label: "ARV Estimate",
            value: arvEstimate === null ? "Reasoning.." : formatterLong.format(arvEstimate).replace(".00", "")
        },
        {
            label: "ARV Estimate Range",
            value: arvEstimate === null ? "Reasoning.." : `${formatterLong.format(arvRange.lower).replace(".00", "")} - ${formatterLong.format(arvRange.upper).replace(".00", "")}`
        }
    ];

    return (
        <div className="arv-estimate-top-container">
            {
                values.map((item, index) =>
                    <div 
                        className="arv-estimate-top-element"
                        key={index}
                    >
                        <span className="body-regular colour-primary">
                            {item.label}
                        </span>
                        <span className="body-bold colour-primary">
                            {item.value}
                        </span>
                    </div>
                )
            }
        </div>
    )
};

export default ARVEstimateHeading;